import css from "styled-jsx/css";
import Colors from "styles/colors";

export const componentStyles = css.global`
  .header-menu-section-item-component {
    display: flex;
    height: 100%;
    width: 100%;
    cursor: pointer;
    align-items: center;
    transition: background-color 200ms ease;
    text-decoration: none;
    color: ${Colors.black};
    &:not([href]) {
      cursor: default;
    }
    .header-menu-item-content {
      display: flex;

      &.has-image-instead-title {
        flex-direction: column;
      }

      .menu-item-title-icon {
        flex-shrink: 0;
        font-size: 0.875rem;
        margin-right: 16px;

        &:not(.fill) {
          path,
          rect,
          circle {
            stroke: var(--icon-color);
          }
        }
      }

      .menu-item-text-wrapper {
        display: flex;
        flex-direction: column;

        .menu-item-title-wrapper {
          display: flex;

          .menu-item-title {
            font-size: 0.875rem;
            font-weight: 400;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            line-height: 20px;
          }

          .new-badge-component-wrapper {
            margin-left: 8px;
          }
        }

        .menu-item-description {
          margin-top: 8px;
          font-size: 0.8125rem;
          line-height: 20px;
          color: ${Colors.asphalt};
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2; /* number of lines to show */
          -webkit-box-orient: vertical;
        }
        .menu-item-description-button {
          margin-top: 16px;
          .secondary-button {
            font-size: 0.8125rem;
          }
        }
      }
    }
  }
`;
